import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ISharedFieldCustomValue, sharedFieldCustomValuesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';

import { getSearchModule } from '../base/search/module';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type ISharedFieldCustomValueByListIdState } from './types';

const SHARED_FIELD_CUSTOM_VALUE_MODULE = 'sharedFieldCustomValue';

const state: ISharedFieldCustomValueByListIdState = {
    byListId: new Map()
};

const dataObjectModule = getDataObjectsModule<ISharedFieldCustomValue>(sharedFieldCustomValuesManager, 3);
const searchModule = getSearchModule<ISharedFieldCustomValue>(sharedFieldCustomValuesManager);

const sharedFieldCustomValuesModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(SHARED_FIELD_CUSTOM_VALUE_MODULE, sharedFieldCustomValuesModuleInstance);

export { SHARED_FIELD_CUSTOM_VALUE_MODULE };
